export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
export const SET_BUSINESS_SEARCH = 'SET_BUSINESS_SEARCH';
export const SET_FIND_BUSINESS_SEARCH = 'SET_FIND_BUSINESS_SEARCH';
export const SET_NEAR_BUSINESS_SEARCH = 'SET_NEAR_BUSINESS_SEARCH';
export const SET_SEARCH_SUGGESTION = 'SET_SEARCH_SUGGESTION';
